import { MapViewerConfiguration } from "../../config/map-viewer-configuration";
import { DataTransporter } from "../data-transporter";
import { computed, makeObservable, observable } from "mobx";

export class UserStore {
    mapViewerConfig: MapViewerConfiguration;
    dataTransporter: DataTransporter;
    users: User[];

    constructor(mapViewerConfig: MapViewerConfiguration, dataTransporter: DataTransporter) {
        this.mapViewerConfig = mapViewerConfig;
        this.dataTransporter = dataTransporter;
        this.users = [];
    }

    async loadAll(): Promise<User[]> {
        this.users = [];
        const result = await this.dataTransporter.get(`${this.mapViewerConfig.api_base_url}/users`);
        const userDtos: UserDto[] = result.data;
        userDtos.forEach(u => this.users.push(new User(u)));
        return this.users;
    }

    async load(id: number): Promise<User> {
        const result = await this.dataTransporter.get(`${this.mapViewerConfig.api_base_url}/users/${id}`);
        const userDto: UserDto = result.data;
        const user = new User(userDto);
        this.users.push(user);
        return user;
    }
}

export class User {
    userDto: UserDto;

    constructor(userDto: UserDto) {
        this.userDto = userDto;
        makeObservable(this, {
            userDto: observable,
            id: computed,
            firstName: computed,
            lastName: computed,
            emailLogin: computed,
            email: computed,
            phone: computed,
            enabled: computed,
        })
    }

    get id(): number {
        return this.userDto.id;
    }

    get firstName(): string {
        return this.userDto.firstName;
    }

    get lastName(): string {
        return this.userDto.lastName;
    }

    get fullName(): string {
        return this.firstName + " " + this.lastName;
    }

    get emailLogin(): string {
        return this.userDto.emailLogin;
    }

    get email(): string {
        return this.userDto.email;
    }

    get phone(): string {
        return this.userDto.phone;
    }

    get enabled(): boolean {
        return this.userDto.enabled;
    }
}

export type UserDto = {
    id: number;
    firstName: string;
    lastName: string;
    emailLogin: string;
    email: string;
    phone: string;
    enabled: boolean;
    roleIds: number[];
}
